import GlobeSvg from '@assets/images/svg/globe.svg';
import TriangleAlertSvg from '@assets/images/svg/triangle-alert.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface GlobeLockIconProps {
    size?: number;
    globeColor?: string;
    alertColor?: string;
}

/**
 * GlobeLockIcon - Combines globe icon with triangle alert icon
 * Used for 404 error pages
 */
export function GlobeLockIcon({ 
    size = 164, 
    globeColor = '#CCCCCC',
    alertColor = '#D8181E'
}: GlobeLockIconProps) {
    // Triangle alert size is approximately 45% of globe size based on Figma design
    const alertSize = size * 0.45;
    
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            {/* Globe icon */}
            <View style={styles.globeContainer}>
                <GlobeSvg
                    width={size}
                    height={size}
                    color={globeColor}
                />
            </View>
            
            {/* Triangle alert positioned on top-right */}
            <View style={[styles.alertContainer, { 
                width: alertSize, 
                height: alertSize,
                top: size * -0.0365, // Position from Figma: -3.65%
                right: size * -0.0411, // Position from Figma: -4.11%
            }]}>
                <TriangleAlertSvg
                    width={alertSize}
                    height={alertSize}
                    color={alertColor}
                />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
    },
    globeContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    alertContainer: {
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

